// @flow
import { APICore } from './apiCore';
import config from '../../config';

const api = new APICore();

/**
 * Create a new Document
 * @param {*} params
 * @returns
 */
function createDocument(params: any): any {
    const baseUrl = `${config.server.api}/v1/documents`;
    return api.create(baseUrl, params.data);
}

/**
 * Update the details of a Document
 * @param {*} params
 * @returns
 */
function updateDocument(params: any): any {
    const baseUrl = `${config.server.api}/v1/documents/${params.id}`;
    return api.updatePatch(baseUrl, params.data);
}

/**
 * Get a single document by ID
 * @param {*} params
 * @returns
 */
function getDocument(params: any): any {
    const baseUrl = `${config.server.api}/v1/documents/${params.id}`;
    return api.get(baseUrl);
}

/**
 * Get all documents (paginated / filtered)
 * @param {*} params
 * @returns
 */
function getDocuments(params: any = {}): any {
    const baseUrl = `${config.server.api}/v1/documents`;
    return api.get(baseUrl, params);
}

/**
 * Get documents for a transaction
 */
function getDocumentsByTransaction(params: any): any {
    const url = `${config.server.api}/v1/documents/transaction/${params.id}`;
    return api.get(url);
}

/**
 * Get documents for multiple transactions
 */
function getDocumentsByTransactions(params: any): any {
    const baseUrl = `${config.server.api}/v1/transactions/documents?ids=${params.ids}`;
    return api.get(`${baseUrl}`);
  }
  

/**
 * Get documents for a listing
 * @param {*} params
 * @returns
 */
function getDocumentsByListing(params: any): any {
    const baseUrl = `${config.server.api}/v1/documents/listing/${params.id}`;
    return api.get(baseUrl);
}

/**
 * Get documents for an owner (user)
 * @param {*} params
 * @returns
 */
function getDocumentsByOwner(params: any): any {
    const baseUrl = `${config.server.api}/v1/documents/owner/${params.id}`;
    return api.get(baseUrl);
}

/**
 * Delete a document
 * @param {*} params
 * @returns
 */
function deleteDocument(params: any): any {
    const baseUrl = `${config.server.api}/v1/documents/${params.id}`;
    return api.delete(baseUrl);
}

export {
    createDocument,
    updateDocument,
    getDocument,
    getDocuments,
    getDocumentsByTransaction,
    getDocumentsByTransactions,
    getDocumentsByListing,
    getDocumentsByOwner,
    deleteDocument,
};
